module.exports = __webpack_public_path__ + "static/img/tiyu.136b57c4.png";